import * as React from 'react';
import cls from 'classnames';
import './index.less';
import { addUnit, isCssVarBind, removeUnit as originRemoveUnit } from '../../utils';
import LayoutInput from './LayoutInput';
var KEY_ARROW_DOWN = 'ArrowDown';
var KEY_ARROW_UP = 'ArrowUp';
var removeUnit = function removeUnit(value) {
  if (isCssVarBind(value)) {
    return value;
  }
  return originRemoveUnit(value);
};
export default (function (props) {
  var onStyleChange = props.onStyleChange,
    _props$unit = props.unit,
    unit = _props$unit === void 0 ? 'px' : _props$unit,
    styleData = props.styleData,
    layoutPropsConfig = props.layoutPropsConfig;
  var onInputChange = function onInputChange(styleKey, value) {
    if (value != '') {
      // 判断是否是数字
      if (!isNaN(parseInt(value))) {
        onStyleChange([{
          styleKey: styleKey,
          value: addUnit(value, unit)
        }]);
      }
    } else {
      onStyleChange([{
        styleKey: styleKey,
        value: null
      }]);
    }
  };
  var onInputKeyDown = function onInputKeyDown(key, styleKey) {
    var onStyleChange = props.onStyleChange,
      _props$unit2 = props.unit,
      unit = _props$unit2 === void 0 ? 'px' : _props$unit2,
      styleData = props.styleData;
    var value = styleData[styleKey] || 0;
    if (key == KEY_ARROW_DOWN) {
      onStyleChange([{
        styleKey: styleKey,
        value: addUnit(parseInt(value) - 1, unit)
      }]);
    } else if (key == KEY_ARROW_UP) {
      onStyleChange([{
        styleKey: styleKey,
        value: addUnit(parseInt(value) + 1, unit)
      }]);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "layout-box-container"
  }, layoutPropsConfig.isShowMargin && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cls("margin-top-div", isCssVarBind(styleData.marginTop) && 'css-var-bind')
  }, /*#__PURE__*/React.createElement(LayoutInput, {
    className: "next-noborder",
    placeholder: "0",
    maxLength: 3,
    value: removeUnit(styleData.marginTop),
    onChange: function onChange(val) {
      return onInputChange('marginTop', val);
    },
    onKeyDown: function onKeyDown(e) {
      return onInputKeyDown(e.key, 'marginTop');
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: cls("margin-right-div", isCssVarBind(styleData.marginBottom) && 'css-var-bind')
  }, /*#__PURE__*/React.createElement(LayoutInput, {
    className: "next-noborder",
    placeholder: "0",
    maxLength: 3,
    value: removeUnit(styleData.marginRight),
    onChange: function onChange(val) {
      return onInputChange('marginRight', val);
    },
    onKeyDown: function onKeyDown(e) {
      return onInputKeyDown(e.key, 'marginRight');
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: cls("margin-bottom-div", isCssVarBind(styleData.marginBottom) && 'css-var-bind')
  }, /*#__PURE__*/React.createElement("span", {
    className: "help-txt"
  }, "MARGIN"), /*#__PURE__*/React.createElement(LayoutInput, {
    className: "next-noborder",
    placeholder: "0",
    maxLength: 3,
    value: removeUnit(styleData.marginBottom),
    onChange: function onChange(val) {
      return onInputChange('marginBottom', val);
    },
    onKeyDown: function onKeyDown(e) {
      return onInputKeyDown(e.key, 'marginBottom');
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: cls("margin-left-div", isCssVarBind(styleData.marginLeft) && 'css-var-bind')
  }, /*#__PURE__*/React.createElement(LayoutInput, {
    className: "next-noborder",
    placeholder: "0",
    maxLength: 3,
    value: removeUnit(styleData.marginLeft),
    onChange: function onChange(val) {
      return onInputChange('marginLeft', val);
    },
    onKeyDown: function onKeyDown(e) {
      return onInputKeyDown(e.key, 'marginLeft');
    }
  }))), layoutPropsConfig.isShowPadding && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cls("padding-top-div", isCssVarBind(styleData.paddingTop) && 'css-var-bind')
  }, /*#__PURE__*/React.createElement(LayoutInput, {
    className: "next-noborder",
    placeholder: "0",
    maxLength: 3,
    value: removeUnit(styleData.paddingTop),
    onChange: function onChange(val) {
      return onInputChange('paddingTop', val);
    },
    onKeyDown: function onKeyDown(e) {
      return onInputKeyDown(e.key, 'paddingTop');
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: cls("padding-right-div", isCssVarBind(styleData.paddingRight) && 'css-var-bind')
  }, /*#__PURE__*/React.createElement(LayoutInput, {
    className: "next-noborder",
    placeholder: "0",
    maxLength: 3,
    value: removeUnit(styleData.paddingRight),
    onChange: function onChange(val) {
      return onInputChange('paddingRight', val);
    },
    onKeyDown: function onKeyDown(e) {
      return onInputKeyDown(e.key, 'paddingRight');
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: cls("padding-bottom-div", isCssVarBind(styleData.paddingBottom) && 'css-var-bind')
  }, /*#__PURE__*/React.createElement("span", {
    className: "help-txt"
  }, "PADDING"), /*#__PURE__*/React.createElement(LayoutInput, {
    className: "next-noborder",
    placeholder: "0",
    maxLength: 3,
    value: removeUnit(styleData.paddingBottom),
    onChange: function onChange(val) {
      return onInputChange('paddingBottom', val);
    },
    onKeyDown: function onKeyDown(e) {
      return onInputKeyDown(e.key, 'paddingBottom');
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: cls("padding-left-div", isCssVarBind(styleData.paddingLeft) && 'css-var-bind')
  }, /*#__PURE__*/React.createElement(LayoutInput, {
    className: "next-noborder",
    placeholder: "0",
    maxLength: 3,
    value: removeUnit(styleData.paddingLeft),
    onChange: function onChange(val) {
      return onInputChange('paddingLeft', val);
    },
    onKeyDown: function onKeyDown(e) {
      return onInputKeyDown(e.key, 'paddingLeft');
    }
  }))));
});